module.exports = __webpack_public_path__ + "img/ai-card-img3.27a28549.png";